<template>
    <BaseModal
        :id="'unassigned-work-modal'"
        :title="title"
        :size="'md'"
      >
          <template v-slot:breadcrumb>
              <Breadcrumb :breadcrumb="breadcrumb_modal"/>
          </template>
  
          <template v-slot:content >
                <form @submit.prevent="addUnassignedWorkItem()">
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <div class="shadow-none mb-2 bg-light rounded" style="vertical-align: center; border: .7px solid black;" >
                                <div class="row  py-0 px-4">
                                    <div class="col-md-3 formdynamic__item__field mt-2" id="minutes">
                                    <label v-html="`Minutes <b style='color:red;'>*</b>`" for="minutes" class="modal-label"/>
                                        <input 
                                        type="number"
                                        step='0.01'
                                        placeholder="Enter the minutes"
                                        v-model="single_object.minutes"
                                        required
                                        />
                                    </div>
                                    <div class="col-md-7 formdynamic__item__field mt-2" id="description">
                                        <label v-html="`Description of work <b style='color:red;'>*</b>`" for="description" class="modal-label"/>
                                        <select 
                                        style="max-width:100%"
                                        class="custom-select"
                                        placeholder="Enter the description"
                                        required
                                        v-model="single_object.unassigned_work_header_id">
                                            <option value='' v-html="'Select an option'"/>
                                            <option :key="index" v-for="(item, index) in unassigned_work_headers" :value="item.id" v-html="item.description" />
                                        </select>
                                    </div>
                                    <div class="col-md-2 mt-2 formdynamic__item__field" id="description" >
                                        <div class="modal__buttons text-center">
                                            <button class="modal__buttons__item" v-html="`Add`" style="width: 4rem"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <form @submit.prevent="formSubmit()">
                    <div class="col-md-12 py-0 px-0" style="margin-bottom: 3rem" v-if="unassigned_work_items.length">
                        <div class="table-responsive table-without-border table-fix-head" style="max-height: 40vh;">
                            <table class="table"  style="border-collapse: collapse; border-spacing: 0;">
                                <thead>
                                    <tr>
                                        <th scope="col" class="header-item border-header-column">Minutes</th>
                                        <th scope="col" class="header-item border-header-column">Description of work</th>
                                        <th scope="col" class="header-item" style="background-color: #fff"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index ) in unassigned_work_items" :key="index">
                                    <td style="width: 5%">
                                        <div class="formdynamic__item__field" id="minutes" >
                                            <input 
                                            :id="index + '-minutes'"
                                            style="max-width: 100%"
                                            placeholder="Enter the minutes"
                                            required
                                            :disabled="item.disabled"
                                            v-model="item.minutes"
                                            />
                                        </div>
                                    </td>
                                    <td style="width: 60%; padding-right: 0;">
                                        <div class="formdynamic__item__field" id="description" >
                                            <select 
                                            :id="index + '-description'"
                                            style="max-width:100%"
                                            class="custom-select"
                                            placeholder="Enter the description"
                                            :disabled="item.disabled"
                                            required
                                            v-model="item.unassigned_work_header_id">
                                                <option value='' v-html="'Select an option'"/>
                                                <option :key="index" v-for="(item, index) in unassigned_work_headers" :value="item.id" v-html="item.description" />
                                            </select>
                                        </div>
                                    </td>
                                    <td  style="vertical-align: center; width:35%">
                                        <div class="modal__buttons text-center" style="margin-top: 0.4rem">
                                            <button type="button" class="modal__buttons__item" v-html="`${item.disabled ? 'Edit' : 'Done'}`" style="width: 3rem" @click="changeDisabled(index)"/>
                                            <button type="button" class="modal__buttons__item cancel" v-html="`Remove`" style="width: 4rem" @click="removeUnassignedWorkItem(index)"/>
                                        </div>
                                    </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                  </div>
                  <CentralLiteButtons save_text="Save & Close"/>
                </form>
          </template>
      </BaseModal>
  </template>
  
<script>

import Breadcrumb         from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal          from    '@/components/BaseModal'
import CentralLiteButtons from    '@/components/CentralLiteButtons'

export default {
name: "FormModalUnassignedWork",
props: [
    "title",
    "notyf",
    "parent_id",
    "daily_assignment",
    "breadcrumb_modal",
],

    components:{
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
    },

    data(){
        return{
            rest_api: 'unassigned_work_items',
            single_object: 
            {
                minutes: '',
                unassigned_work_header_id: '',
                is_new: true,
                is_dirty: false,
                disabled: true,
            },

            items_to_delete: [],
            unassigned_work_items: [],
            unassigned_work_headers: []
        }
    },

    methods: 
    {
        async initialFunction()
        {
            const http_object = {
                viewing_all: false,
                daily_assignment_id: this.daily_assignment.decrypted_id
            }

            const response = await this.post(`${this.rest_api}/show`, http_object);

            if(response.status)
            {

                this.unassigned_work_items = response.data.unassigned_work_items
                this.unassigned_work_headers = response.data.unassigned_work_headers
            }
            else
            {
                this.error_handling(response)
            }

        },

        addUnassignedWorkItem()
        {
            this.unassigned_work_items.push({...this.single_object})
            
            this.single_object.unassigned_work_header_id = ''
            this.single_object.minutes = '';
        },

        removeUnassignedWorkItem(index)
        {   
            (this.unassigned_work_items[index].id) ? this.items_to_delete.push(this.unassigned_work_items[index].id) : null
            
            this.unassigned_work_items.splice(index, 1);
        },
        
        changeDisabled(index)
        {
            this.unassigned_work_items[index].disabled = !this.unassigned_work_items[index].disabled
            this.unassigned_work_items[index]['is_dirty'] = true
        },

        formSubmit()
        {
            const single_object = {
                daily_assignment_id: this.daily_assignment.decrypted_id,
                unassigned_work_items: this.unassigned_work_items,
                items_to_delete: this.items_to_delete,
                supervisor_view: false,
            }
            this.form_submit('unassigned-work-modal', single_object)
        }
    },
    
};
</script>